<style lang="scss" scoped>
.add {
  width: 100%;
  height: 100%;
  text-align: center;
  color: #9b9b9b;
  position: relative;
  cursor: pointer;
  border: 1px dashed #dcdfe6;
  &:hover {
    border-color: #4a4a4a;
  }
}
i {
  font-size: 40px;
  display: block;
  margin: 0 auto 10px;
}
</style>

<template>
  <div class="add">
    <div class="center">
      <i class="el-icon-plus"></i>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>
